import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import { accountWithDigitMask } from "../../../../../utils/OnlyNumbers";
import "./styles.css";

const ExecutiveAccountDataCard: React.FC<{
  tipoConjConta?: string, titularConta?: string, cpfTitular?: string,
  banco?: string, agencia?: string, numConta?: string, tipoConta?: string
}> = ({ tipoConjConta, agencia, banco, cpfTitular, numConta, tipoConta, titularConta }) => {

  const accessibility = useAccessibility();

  return (
    <div className="registration-data-card-holder">
      <div className="registration-data-card" tabIndex={0} style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
        <div className="registration-data-row">
          <span style={accessibility.textStyleAccessibility} className="registration-data-title">Dados da conta</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
          <span style={accessibility.textStyleAccessibility} className="registration-data-key">Tipo</span>
          <span style={accessibility.textStyleAccessibility} className="registration-data-value">{tipoConjConta}</span>
        </div>
        <div className="registration-data-row">
          <span style={accessibility.textStyleAccessibility} className="registration-data-key">Titular da conta</span>
          <span style={accessibility.textStyleAccessibility} className="registration-data-value">{titularConta}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
          <span style={accessibility.textStyleAccessibility} className="registration-data-key">CPF do titular</span>
          <span style={accessibility.textStyleAccessibility} className="registration-data-value">{cpfTitular}</span>
        </div>
        <div className="registration-data-row">
          <span style={accessibility.textStyleAccessibility} className="registration-data-key">Banco</span>
          <span style={accessibility.textStyleAccessibility} className="registration-data-value">{banco}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
          <span style={accessibility.textStyleAccessibility} className="registration-data-key">Agência</span>
          <span style={accessibility.textStyleAccessibility} className="registration-data-value">{agencia}</span>
        </div>
        <div className="registration-data-row">
          <span style={accessibility.textStyleAccessibility} className="registration-data-key">Número da conta</span>
          <span style={accessibility.textStyleAccessibility} className="registration-data-value">{accountWithDigitMask(numConta || '')}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary radius-bottom" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
          <span style={accessibility.textStyleAccessibility} className="registration-data-key">Tipo da conta</span>
          <span style={accessibility.textStyleAccessibility} className="registration-data-value">{tipoConta}</span>
        </div>
      </div>
    </div>
  )
}

export default ExecutiveAccountDataCard;